import React, { memo } from 'react';
import { isMobile } from 'react-device-detect';
import { useAddLike, useAddVault } from '../../../Queries/QueryHooks/clvideo.hook';
import '../../../assets/sass/uiV3/component/_contentActionIcons.scss';
import DetailsPageShareButton from '../../DetailsPageShareButton';
import TooltipContainer from './TooltipContainer';
function DetailsPageActions({
  myrating,
  type = 'comp',
  type_id,
  rating,
  comment_count,
  vault,
  question,
  deeplink,
  dontShowComments = false
}) {
  const onVaultPress = () => {
    let obj = { postid: type_id, type: type };
    saveVault(obj);
  };
  const { mutate: saveVault } = useAddVault(type, type_id);
  const { mutate: saveLike } = useAddLike(type, type_id);
  const onLikePress = () => {
    saveLike({ type, type_id });
  };

  function commentClick() {
    if (isMobile) {
      document.getElementById('CommentBoxInput').focus();
    } else {
      window.scrollTo({
        top:
          document.getElementById('detailsComments')?.getBoundingClientRect().top -
          document.body.getBoundingClientRect().top -
          document.getElementById('headerDesktopNavBar')?.clientHeight +
          -10
      });
      document.getElementById('CommentBoxInput').focus();
    }
  }

  return (
    <ul
      className={`list-unstyled gap-4 justify-content-between d-flex align-items-center m-0 p-0 clr_v3_contentAction--Details ${
        isMobile ? 'clr_v3_contentAction--mobile' : 'clr_v3_contentAction--desktop'
      }`}
    >
      <TooltipContainer text={myrating ? 'Unlike' : 'Like'} placement="bottom">
        <li
          className={`cursorPointer d-flex align-items-center gap-n2 align-items-center clr_v3_contentActionIcons border-soft-primary ${
            myrating ? 'active' : ''
          } gtm_cl_medwiki_detail_like_unlike`}
          onClick={onLikePress}
        >
          <span className="icon-size-32 flex-shrink-0 d-flex align-items-center justify-content-center rounded-pill ripple-primary rippleEffect position-relative fs-3 medwiki_detail_likeUnlike_icon_section">
            {myrating ? (
              <i
                className="flaticon-heart-1 position-absolute top-50 start-50 translate-middle text-primary"
                gtmTagVariable="gtm_cl_medwiki_detail_like_unlike"
              ></i>
            ) : (
              <i
                className="flaticon-heart position-absolute top-50 start-50 translate-middle"
                gtmTagVariable="gtm_cl_medwiki_detail_like_unlike"
              ></i>
            )}
          </span>
          {parseInt(rating) == 0 ? (
            <></>
          ) : (
            <span className="clr_v3_contentActionIcons__count bg-soft-primary">{rating}</span>
          )}
        </li>
      </TooltipContainer>
      {!!comment_count && !dontShowComments && (
        <TooltipContainer text={'Comments'} placement="bottom">
          <li
            className="cursorPointer d-flex align-items-center gap-n2 align-items-center clr_v3_contentActionIcons border-soft-primary"
            onClick={commentClick}
          >
            <span className="icon-size-32 flex-shrink-0 d-flex align-items-center justify-content-center rounded-pill ripple-primary rippleEffect position-relative fs-3">
              {/* <IoChatbubblesOutline
                customClass="lineIcon position-absolute top-50 start-0 translate-middle-y"
                gtmTagVariable="gtm_cl_medwiki_detail_comment"
              /> */}
              <i className="flaticon-bubble-chat position-absolute top-50 start-50 translate-middle"></i>
            </span>
            {comment_count === '0' ? (
              ''
            ) : (
              <span className="clr_v3_contentActionIcons__count bg-soft-primary">
                {comment_count}
              </span>
            )}
          </li>
        </TooltipContainer>
      )}
      <TooltipContainer text={vault == 1 ? 'Unsave' : 'Save'} placement="bottom">
        <li
          className={`cursorPointer d-flex align-items-center gap-n2 align-items-center clr_v3_contentActionIcons border-soft-primary ${
            vault == 1 ? 'active' : ''
          } gtm_cl_medwiki_detail_vault_save_unsave`}
          onClick={() => {
            onVaultPress(type_id);
          }}
        >
          <span className="icon-size-32 flex-shrink-0 d-flex align-items-center justify-content-center rounded-pill ripple-primary rippleEffect position-relative fs-3">
            {vault == 1 ? (
              <i
                className="flaticon-bookmark position-absolute top-50 start-50 translate-middle text-primary"
                gtmTagVariable="gtm_cl_medwiki_detail_vault_save_unsave"
              ></i>
            ) : (
              <i
                className="flaticon-save-instagram position-absolute top-50 start-50 translate-middle"
                gtmTagVariable="gtm_cl_medwiki_detail_vault_save_unsave"
              ></i>
            )}
          </span>
        </li>
      </TooltipContainer>

      <DetailsPageShareButton
        gtmTagVariable="gtm_cl_medwiki_detail_share"
        buttonText={''}
        customClass="position-absolute top-50 start-50 translate-middle"
        data={{
          title: question,
          url: deeplink
        }}
      />
    </ul>
  );
}

export default memo(DetailsPageActions);
